'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  max-width: ', '; \n  padding: ', ';\n  margin: ', ';\n  ', '\n'], ['\n  max-width: ', '; \n  padding: ', ';\n  margin: ', ';\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentContainer = _styledComponents2.default.div(_templateObject, function (props) {
  if (props.contentWidth) return props.contentWidth;
  return '900px';
}, function (props) {
  if (props.contentPadding) return props.contentPadding;
  return '20px';
}, function (props) {
  if (props.contentMargin) return props.contentMargin;
  return '0 auto';
}, function (props) {
  return props.height && 'height: ' + props.height + ';';
});

exports.default = ContentContainer;
//# sourceMappingURL=ContentContainer.js.map


//////////////////
// WEBPACK FOOTER
// ../content-container/lib/ContentContainer.js
// module id = 337
// module chunks = 0